import { DateTime } from 'luxon';

// A calendar date ('YYYY-MM-DD', no time) must display as that day in every
// timezone. Parsing in UTC and formatting in UTC never shifts it; the shared
// date helpers parse at local midnight or reject the bare date. Expects
// date-only values: an offset timestamp is converted to UTC, not kept as-is.
export function formatDateOnly(
	value: string | null | undefined,
	dateFormat: string,
): string | null {
	if (!value) return null;
	const date = DateTime.fromISO(value, { zone: 'utc' });
	return date.isValid ? date.toFormat(dateFormat) : null;
}
